/**
 * Mate (conductor) lines, mainly Twi with some Ga (Ojekoo, Oyiwaladonn, Ofainɛ, yaa sɛɛ).
 * {stop} is replaced with the stop name. Native speakers: edit freely.
 */
export const MATE_LINES = {
  runStart: ['Master, yaaa sɛɛ!', 'Yɛnkɔ! Driver, pia!', 'Ofainɛ, mo nyinaa tena ase. Yɛnkɔ!'],
  stopAhead: ['{stop}! {stop}! Kɔ nifa so, driver!', "Gyinabea wɔ w'anim. Gyina yellow box no mu!", '{stop} reba o!'],
  boarding: ['Bra, bra! Tena ase!', 'Mo mra! Baabi wɔ hɔ!', 'Ofainɛ, bra mu! Baabi wɔ akyi!'],
  perfectStop: ['Ojekoo, driver!', 'Ayekoo! Wo nim adeɛ!', 'Paa! Ɛyɛ!'],
  overshot: ['Herh! Woatra gyinabea no!', 'Driver, wo ani wɔ he?', 'Yɛnkɔ gyinabea a ɛdi hɔ!'],
  missedDrop: ['Mate! Me si ha! Woatra me gyinabea!', 'Driver, meka sɛ {stop}!'],
  drop: ['{stop}! Hwan na ɔresi?', 'Me si ha! Oyiwaladonn, driver!', 'Bus stop! Ma me nsi!'],
  stumble: ["Awurade! Driver, brɛ wo ho ase!", 'Ei! Me nneɛma!', 'Driver, wopɛ sɛ wokum yɛn?'],
  crash: ['EI CHALE!', 'Yɛawie!', 'Awurade, boa yɛn!'],
  rearEnd: ['Driver! Woabɔ obi akyi!', 'Polisifoɔ bɛkyere yɛn!', 'Herh! Brake no wɔ he?'],
  brokeDown: ['Master, car nu asɛi. Frɛ fita!', 'Yɛawie. Ɛnjin no agyae adwuma.'],
  pedestrian: ['Driver! Nnipa retwa kwan! Awurade!', 'Zebra no yɛ nnipa dea!'],
  uTurn: ['{stop}! Obiara nsi! Yɛresan akɔ!', 'Last stop! {stop}! Chale, yaaa sɛɛ back.', 'Gyinabea a ɛtwa toɔ! Yɛnkɔ bio!'],
  redAhead: ['Driver, kanea no ayɛ kɔkɔɔ o!', 'Kanea kɔkɔɔ! Gyina, gyina!', 'Polisifoɔ wɔ junction no so!'],
  ranRed: ['Herh! Woatra kanea no!', 'Polisifoɔ bɛkyere yɛn nnɛ!', 'Awurade! Kanea kɔkɔɔ nyɛ agorɔ!'],
  fuelLow: ['Driver, petrol no ɛrekɔ awie o!', 'Ɛnjin no repɛ petrol. Hwɛ fuel gauge no!', 'Driver, kɔ petrol station no ntɛm!'],
  fuelEmpty: ['Petrol awie! Ɛnjin no agyae!', 'Eiii! Yɛn petrol awie nnɛ!'],
  fuelFull: ['Ɛyɛ! Tank no ayɛ ma. Yɛnkɔ!', 'Petrol no ayɛ ma, driver. Pia!'],
  checkpointAhead: ['Polisifoɔ wɔ w\'anim! Gyina!', 'Driver, polisifoɔ no regyina yɛn. Brake!', 'Check point! Hwɛ w\'ani!'],
  checkpointRan: ['Herh! Woatra polisifoɔ no! Yɛn nsa bɛka!', 'Driver! Polisifoɔ no hunu yɛn!'],
  checkpointOk: ['Ɛyɛ. Wo nkrataa no yɛ. Yɛnkɔ!', 'Polisifoɔ no ma yɛn kwan. Ɛyɛ!'],
  checkpointPapers: ['Ɔhene! Wo nkrataa no wɔ hwanyadzi. Tua kakra!', 'Ei, polisifoɔ no pɛ sika kakra...'],
  dashAsk: ['Driver, Aban reka ne nsa. Ma no biribi kakra!', 'Aban pɛ "something small". Ma no ɛkɔ!', 'Chale, polisifoɔ no rehwehwɛ dash. Sɛ wo pɛ a, ma no!'],
  dashPaid: ['Ɛyɛ! Aban se all good. Yɛnkɔ!', 'Wo ayɛ yie! Polisifoɔ no ma yɛn kwan.'],
  dashRefused: ['Eii driver! Aban bɛhwɛ wo nkrataa nyinaa o...', 'Daabi? Yɛbɛtena ha kakra.'],
} as const;

export type MateMoment = keyof typeof MATE_LINES;
